import React from 'react'
import { Grid, Segment } from 'semantic-ui-react'

import Exercises from './exercises'
import { tr } from '../../../helpers/languages'

const CompletedExercises = (props) => {
    return (
        <Segment className='completed-exercises' id='completed-exercises'>
            <Segment className='assigned-exercises'>
                <Segment className='exercises-title'>{tr('ASSIGNED_EXERCISES')}</Segment>
                <Grid className='exercises-header'>
                    <Grid.Row>
                        <Grid.Column className='name'>{tr('NAME')}</Grid.Column>
                        <Grid.Column className='status'>{tr('STATUS')}</Grid.Column>
                    </Grid.Row>
                </Grid>
                <Exercises
                    exercises={props.exercises.filter((e) => { return e.type === 'assigned' })}
                    onClickOnMoodJournals={props.onClickOnMoodJournals}
                />
            </Segment>
            <Segment className='additional-exercises'>
                <Segment className='exercises-title'>{tr('ADDITIONAL_EXERCISES')}</Segment>
                <Grid className='exercises-header'>
                    <Grid.Row>
                        <Grid.Column className='name'>{tr('NAME')}</Grid.Column>
                        <Grid.Column className='status'>{tr('STATUS')}</Grid.Column>
                    </Grid.Row>
                </Grid>
                <Exercises
                    exercises={props.exercises.filter((e) => { return e.type === 'default' })}
                    onClickOnMoodJournals={props.onClickOnMoodJournals}
                />
            </Segment>
            <Segment className='additional-exercises'>
                <Segment className='exercises-title'>{tr('MOOD_BOOSTERS')}</Segment>
                <Grid className='exercises-header'>
                    <Grid.Row>
                        <Grid.Column className='name'>{tr('NAME')}</Grid.Column>
                        <Grid.Column className='status'>{tr('STATUS')}</Grid.Column>
                    </Grid.Row>
                </Grid>
                <Exercises
                    exercises={props.moodBoosters}
                    onClickOnMoodJournals={props.onClickOnMoodJournals}
                />
            </Segment>
        </Segment>
    )
}

export default CompletedExercises



// WEBPACK FOOTER //
// ./src/components/common/completed-exercises/index.js